<div class="form-card">
  <form class="form">
      <div class="saldo">
        <p>Valor disponível para reembolso</p>
        <app-input-currency [inputModel]="reembolsoModel.valorInputModel" [(value)]="reembolsoModel.ValorToShow"></app-input-currency>
        <label *ngIf="routeParams['tipoReembolso'] === '1'">Saldo disponível R${{dependent.Saldo.toFixed(2)}}</label>
      </div>

      <div class="input-line input-break">
        <div>
          <label>Nome <span class="required">*</span></label>
          <app-input
            class="field field-name"
            [inputModel]="reembolsoModel.ContaBancaria.NomeTitularInputModel"
            (isInputValid)="setFormStatus($event, 'NomeTitularInputModel')"
            [(value)]="reembolsoModel.ContaBancaria.NomeTitular">
          </app-input>
        </div>
        <div>
          <label>CPF do titular <span class="required">*</span></label>
          <app-input
            class="field"
            [inputModel]="reembolsoModel.ContaBancaria.CPFInputModel"
            [(value)]="reembolsoModel.ContaBancaria.CPF">
          </app-input>
        </div>
      </div>

      <div class="input-line">
        <div>
          <label>DDD <span class="required">*</span></label>
          <app-input
            class="field field-small"
            [inputModel]="reembolsoModel.dddInputModel"
            [(value)]="reembolsoModel.ddd">
          </app-input>
        </div>
        <div>
          <label>Telefone <span class="required">*</span></label>
          <app-input
            class="field"
            [inputModel]="reembolsoModel.celularInputModel"
            [(value)]="reembolsoModel.celular">
          </app-input>
        </div>
      </div>

      <div class="info-dados-bancarios">
        <h5>Dados bancários</h5>
        <div class="infos">
          <i class="material-icons">info_outline</i>
          <div>
            <strong>Utilize uma Conta Corrente</strong>
            <p>Para que sua solicitação seja feita é importante que a conta inserida abaixo seja do tipo corrente.</p>
          </div>
        </div>
      </div>

      <div class="input-line input-line-drop">
        <label>Código do banco <span class="required">*</span></label>
        <app-input-select
          class="field-dropdown"
          [children]="reembolsoModel.ContaBancaria.CodigoBancoInputModel"
          [validators]="['required']"
          (isInputValid)="setFormStatus($event, 'CodigoBancoInputModel')"
          (valueChange)="exibeDigito($event)"
          [(value)]="reembolsoModel.ContaBancaria.CodigoBanco">
        </app-input-select>
      </div>

      <div class="input-line input-break">
        <div>
          <label>Agência <span class="required">*</span></label>
          <app-input
            class="field"
            [inputModel]="reembolsoModel.ContaBancaria.AgenciaInputModel"
            (isInputValid)="setFormStatus($event, 'AgenciaInputModel')"
            [(value)]="reembolsoModel.ContaBancaria.Agencia"
            (input)="onInput($event, 'Agencia')">
          </app-input>
        </div>
        <div *ngIf="deveExibirCampoDigito">
          <label>Dígito <span class="required">*</span></label>
          <app-input
            class="field field-small"
            [inputModel]="reembolsoModel.ContaBancaria.AgenciaDigitoInputModel"
            (isInputValid)="setFormStatus($event, 'AgenciaDigitoInputModel')"
            [(value)]="reembolsoModel.ContaBancaria.AgenciaDigito">
          </app-input>
        </div>
        <div>
          <label>Conta <span class="required">*</span></label>
          <app-input
            class="field"
            [inputModel]="reembolsoModel.ContaBancaria.ContaInputModel"
            (isInputValid)="setFormStatus($event, 'ContaInputModel')"
            [(value)]="reembolsoModel.ContaBancaria.Conta"
            (input)="onInput($event, 'Conta')">
          </app-input>
        </div>
        <div>
          <label>Dígito <span class="required">*</span></label>
          <app-input
            class="field field-small"
            [inputModel]="reembolsoModel.ContaBancaria.ContaDigitoInputModel"
            (isInputValid)="setFormStatus($event, 'ContaDigitoInputModel')"
            [(value)]="reembolsoModel.ContaBancaria.ContaDigito">
          </app-input>
        </div>
      </div>
      <div class="midle-width">
        <label>PIX</label>
        <app-input
          class="field"
          [inputModel]="reembolsoModel.ChavePixInputModel"
          [(value)]="reembolsoModel.ChavePix">
        </app-input>
      </div>
      <mat-slide-toggle (click)="deveSalvar()">Salvar dados para futuros reembolsos</mat-slide-toggle>
  </form>
  <button (click)="solicitar()" class="confirma">
      Solicitar reembolso
  </button>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/reembolso/reembolso.component.html